import styled, { css } from 'styled-components'
import { resources } from './resources'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/landing.css */
  #landing {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    height: calc(100% - 80px);
    overflow-y: auto;
    margin: 80px 0;
  }
  #landing .mp_games {
    width: 80%;
    margin: 0 0 30px 0;
    display: flex;
    align-items: space-between;
    justify-content: space-between;
    line-height: 140%;
    text-align: center;
    flex-wrap: wrap;
    position: relative;
  }
  #landing .game_box {
    background: hsla(0, 0%, 0%, 0.2);
    width: calc(50% - 15px);
    display: flex;
    border-radius: 10px;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    line-height: 140%;
    flex-direction: row;
    padding: 30px;
    text-decoration: none;
  }
  #landing .game_box.infinite_winnings {
    width: 100%;
    height: 850px;
    margin: 0 0 0 0;
    position: relative;
    flex-direction: column;
    padding: 0;
  }
  #landing .game_box.infinite_winnings:hover .top {
    box-shadow: inset 0 0 0 1px hsl(270, 72%, 45%);
  }
  #landing .game_box.infinite_winnings .top {
    background: url(${resources.wsb_transitory_bg}) center center / cover
      no-repeat;
    width: 100%;
    height: 850px;
    z-index: 0;
    box-shadow: inset 0 0 100px 20px hsla(0, 0%, 0%, 0.9);
    border-radius: 10px;
  }
  #landing .game_box.infinite_winnings .top:after {
    background: hsla(0, 0%, 0%, 0.85);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    content: '';
    border-radius: 10px;
  }
  #landing .game_box.infinite_winnings .top:before {
    position: absolute;
    top: calc(50% - 210px);
    left: 50%;
    transform: translate(-50%, -50%);
    content: '';
    width: 100%;
    height: 100%;
    background: url(${resources.wsb_logo_landing}) center center / 750px auto
      no-repeat;
    z-index: 1;
  }
  #landing .game_box.infinite_winnings .bottom {
    position: absolute;
    bottom: 20px;
    background: transparent;
    flex-direction: column;
    display: flex;
    width: 100%;
    padding: 20px 40px;
  }
  #landing .game_box .top {
    width: 100%;
    display: flex;
    min-height: 200px;
    position: relative;
    border-radius: 10px 10px 0 0;
  }
  #landing .game_box .bottom {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    background: hsl(213, 14%, 12%);
    padding: 20px;
    border-radius: 10px;
  }
  #landing .game_box.infinite_winnings .left,
  #landing .game_box.infinite_winnings .right {
    display: flex;
    position: relative;
    z-index: 1;
    flex-direction: column;
  }
  #landing .game_box.infinite_winnings .right .powered_by_landing {
    margin: 30px 0 0 0;
  }
  #landing .game_box.infinite_winnings .left {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
    width: 100%;
    font-size: 0.8rem;
    padding: 0 0 30px 0;
  }
  #landing .game_box.infinite_winnings .left p {
    line-height: 140%;
    font-size: 1.1rem;
    padding: 0 120px;
  }
  #landing .game_box.infinite_winnings .left p strong {
    font-weight: 800;
    font-size: 1.4rem;
    padding: 25px 0 0 0;
    display: block;
  }
  #landing .game_box.infinite_winnings button {
    background: linear-gradient(
      0deg,
      #3d1999,
      #391999,
      #2f189a,
      #1f169b,
      #151f9c,
      #13349d,
      #11499e,
      #0f5f9f,
      #0d74a0,
      #0c85a0,
      #0b91a1,
      #0b95a1
    );
    font-size: 1.6rem;
    font-weight: 700;
    letter-spacing: -0.03em;
    text-transform: uppercase;
    border-radius: 1.2em;
    padding: 20px 100px;
  }
  .landing_level {
    width: 80%;
    border-top: 1px solid hsla(0, 0%, 100%, 0.1);
    position: relative;
    z-index: 0;
    padding: 15px 30px 0 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .landing_level form {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 5px 0;
    position: relative;
    z-index: 1;
    width: 80%;
  }
  .landing_level form input {
    padding: 10px 20px;
    max-width: 300px;
    width: 100%;
    font-size: 0.9rem;
    border-radius: 10px 0 0 10px;
    background: rgba(255, 255, 255, 0.1);
    text-align: left;
    position: relative;
    height: 40px;
    z-index: 2;
  }
  .landing_level form input:focus {
    box-shadow: 0 0 25px 5px rgba(42, 109, 255, 0.7);
    background: rgba(255, 255, 255, 0.5);
  }
  .landing_level form button {
    padding: 10px 20px;
    font-size: 0.9rem;
    border-radius: 0 10px 10px 0;
    white-space: nowrap;
    position: relative;
    z-index: 3;
    height: 40px;
  }
  footer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 0.75rem;
    padding: 15px 60px 30px 60px;
    margin: 0;
    align-items: center;
    position: relative;
    bottom: 0;
    z-index: 11;
    width: 80%;
    flex-wrap: nowrap;
  }
  footer #landing-details {
    display: flex;
    flex-direction: row;
    min-width: auto;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  footer a {
    color: rgba(255, 255, 255, 1);
  }
  footer a:hover {
    text-decoration: underline;
  }
  footer #made-with {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    padding: 5px 15px;
    width: 100%;
  }
  footer #copyright,
  footer #priv-terms {
    white-space: nowrap;
  }
  footer #copyright {
    padding: 5px 15px;
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/res.css */
  @media (max-width: 1200px) {
    #landing .game_box.infinite_winnings .left p {
      line-height: 140%;
      font-size: 1rem;
    }
    #landing .mp_games {
      width: 90%;
    }
  }
  @media (max-width: 800px) {
    #landing .game_box.infinite_winnings .top:before {
      top: calc(50% - 70px);
      background-size: 550px auto;
    }
    #landing .game_box.infinite_winnings .left p {
      line-height: 130%;
      font-size: 0.9rem;
    }
    #landing .game_box.infinite_winnings .left {
      padding: 0 0 15px 0;
    }
    #landing .mp_games {
      width: 95%;
    }
  }
  @media (max-width: 600px) {
    #landing .game_box .top {
      min-height: 150px;
    }
    #landing .game_box.infinite_winnings .top:before {
      top: calc(50% - 50px);
      background-size: 500px auto;
    }
    #landing .game_box.infinite_winnings .left p {
      line-height: 130%;
      font-size: 0.85rem;
    }
    #landing .game_box.infinite_winnings .left {
      padding: 0 0 15px 0;
    }
    #landing .game_box.infinite_winnings .bottom {
      bottom: 10px;
      padding-left: 20px;
      padding-right: 20px;
    }
    #landing .game_box.infinite_winnings {
      height: 300px;
    }
    #landing .game_box.infinite_winnings .top {
      height: 300px;
    }
    #landing .game_box.infinite_winnings .top:before {
      top: calc(50% - 65px);
    }
    #landing .game_box.infinite_winnings button {
      font-size: 1.2rem;
      letter-spacing: -0.02em;
      padding: 15px 40px;
    }
  }
  @media (max-width: 430px) {
    #landing .game_box.infinite_winnings .top:before {
      top: calc(50% - 90px);
      background-size: 450px auto;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/wsb_theme.css */
  * {
    font-weight: 400;
    color: #fff;
  }
  a {
    color: #fff;
    text-decoration-color: rgba(255, 255, 255, 0.4);
  }
  button {
    background: linear-gradient(
      0deg,
      #4511a1,
      #4711a6,
      #4a12ac,
      #4c12b1,
      #4e13b7,
      #5013bc,
      #5314c1,
      #5514c7
    );
    color: #fff;
    border: 0;
  }
  button:hover {
    background: var(--primary-button-hover-background);
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb {
      background-color: hsla(0, 0%, 100%, 0.5);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }
`

const developerCSS = css``

export const WsbLandingCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
